import { Store } from "./src/components/libs/redux/Store";

export const wrapRootElement = Store;
